import React, { useState } from "react";
import "./SamagiriList.scss";

// SVG assets
const imgCaretDown = "/assets/images/caret-down.svg";

const SamagiriList = ({ samagiriData = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Filter samagiri items where isProvidedBy is "user"
  const userSamagiriItems = samagiriData.filter(item => item.isProvidedBy === "user");

  // Format quantity with units
  const formatQuantity = (qty, units) => {
    if (units === "gms" || units === "ml") {
      return `${qty} ${units}`;
    } else if (units === "kgs") {
      return `${qty} ${units}`;
    } else {
      return `${qty}`;
    }
  };

  return (
    <div className="samagiri-container" data-node-id="8946:288">
      <div className="samagiri-content sm:tw-p-[24px]">
        <div className="samagiri-header" data-node-id="8946:289">
          <div className="samagiri-title" data-node-id="8946:290">
            <p>Samagiri to keep ready at Home</p>
          </div>
          <div className="samagiri-toggle" onClick={() => setIsExpanded(!isExpanded)}>
            <div className={`caret-icon ${isExpanded ? 'expanded' : ''}`}>
              <img alt="" src={imgCaretDown} />
            </div>
          </div>
        </div>
        
        {isExpanded && (
          <div className="samagiri-table" data-name="Samagri Table listing" data-node-id="8947:889">
            {/* Table Header */}
            <div className="table-header" data-node-id="8947:890">
              <div className="header-border" />
              <div className="header-content">
                <div className="description-header" data-node-id="8947:891">
                  <div className="header-text" data-node-id="8947:892">
                    <p>Item Description</p>
                  </div>
                </div>
                <div className="quantity-header" data-node-id="8947:893">
                  <div className="header-text" data-node-id="8947:894">
                    <p>Quantity</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Table Rows */}
            {userSamagiriItems.length > 0 ? (
              userSamagiriItems.map((item, index) => (
                <div key={item.id} className="table-row" data-node-id={`8946:${345 + index}`}>
                  <div className={`row-border ${index === userSamagiriItems.length - 1 ? 'orange-border' : ''}`} />
                  <div className="row-content">
                    <div className="description-cell" data-node-id={`8946:${346 + index}`}>
                      <div className="item-text" data-node-id={`8946:${347 + index}`}>
                        <p>{item.samagri?.name || 'N/A'}</p>
                      </div>
                    </div>
                    <div className="quantity-cell" data-node-id={`8946:${348 + index}`}>
                      <div className="quantity-text" data-node-id={`8946:${349 + index}`}>
                        <p>{formatQuantity(item.qty, item.samagri?.units)}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="table-row">
                <div className="row-border orange-border" />
                <div className="row-content">
                  <div className="description-cell">
                    <div className="item-text">
                      <p>No items to keep ready at home</p>
                    </div>
                  </div>
                  <div className="quantity-cell">
                    <div className="quantity-text">
                      <p>-</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        )}
      </div>
      <div className="container-border" />
    </div>
  );
};

export default SamagiriList;
